import { FC, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { IVideoArticleDetail } from 'shared/models';
import { ScopedProvider } from '@lemon8/web-app-shared/ssr';
import { $CurrentVideoArticle, $EndRecommendShow, $ReplayVideo } from './atoms';
import { VideoPlayer } from './components/video-player';
import { VideoWrapper } from './components/video-wrapper';
import { VideoContent } from './components/video-content';
import { WarningLabelSection } from '@article/shared/components/warning-label-section';
import { VideoEndRecommendSection } from '@article/body/main/article-video/components/end-recommend';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { sendNotification } from '~/utils/pwa/notification';
import { ClickPosition } from '~/utils/click-position';
import { generateOneLink } from '~/utils/active';

const ArticleVideoSectionImpl: FC = () => {
  return (
    <section id="article-video">
      <VideoWrapper>
        <VideoPlayer />
        <VideoContent />
        <VideoEndRecommendSection />
        <WarningLabelSection />
      </VideoWrapper>
    </section>
  );
};

export const ArticleVideoSection: FC = () => {
  const article = useAtomValue($CurrentArticle) as IVideoArticleDetail;
  const { title, shortContent, largeImage, groupId } = article;
  const { isBot } = useAtomValue($UserAgent);

  useEffect(() => {
    /** 含有is_notification'说明本次发送过了 */
    if (!sessionStorage.getItem('is_notification') && !isBot) {
      const imgUrl = largeImage && largeImage.url;
      const oneLink = generateOneLink({
        pid: 'website_seo_notification',
        schemaOption: { pageType: 'video', groupId },
        ampExtra: {
          enter_position: ClickPosition.pwa_notification_banner,
          enter_page_id: groupId,
          enter_page_type: 'video',
        },
      });

      sendNotification(title, {
        body: shortContent,
        icon: 'https://p16-va.lemon8cdn.com/tos-maliva-p-0000/5d8e5f313d1b470799f8450327ec6dee~tplv-tej9nj120t-scaling:120:0:q75.jpeg',
        requireInteraction: true,
        image: imgUrl,
        data: {
          time: new Date(Date.now()).toString(),
          url: oneLink,
        },
      });
    }
  }, []);

  return (
    <ScopedProvider atoms={[$EndRecommendShow, $ReplayVideo]} atomsWithHydration={[[$CurrentVideoArticle, article]]}>
      <ArticleVideoSectionImpl />
    </ScopedProvider>
  );
};
